export default () => {
  const defaultParams = {
    stageElement: 'ul',
    itemElement: 'li',
    stagePadding: 20,
    center: false,
    loop: false,
    nav: true,
    navText: ["<i class='fal fa-chevron-left'></i>", "<i class='fal fa-chevron-right'></i>"],
  };
  const responsiveDefault = {
    768: { items: 5 },
    1040: { items: 6 },
  };
  const responsiveSlot66 = {
    768: { items: 4 },
    1040: { items: 4 },
  };

  $('.cont-authors-opinion .cmp-authors-opinion__slider.owl-carousel').each((index, item) => {
    const el = $(item);
    if (el.closest('[data-bbnx-slot-type="slots.grid-66-33.slot-66"]').length) {
      el.owlCarousel({ ...defaultParams, responsive: responsiveSlot66 });
    } else {
      el.owlCarousel({ ...defaultParams, responsive: responsiveDefault });
    }
  });
};
